import { Product, Category } from './types';
import { perfumesImg, giftSetsImg } from '../assets/images';

// Mock product images (these are placeholders and should be replaced with actual product images)
const perfumeImage1 = 'https://images.unsplash.com/photo-1566977776052-050ee2cdcd4c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80';
const perfumeImage2 = 'https://images.unsplash.com/photo-1547887538-0b2f90121745?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80';
const perfumeImage3 = 'https://images.unsplash.com/photo-1592945403244-b3fbafd7f539?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80';
const oudImage1 = 'https://images.unsplash.com/photo-1612968347237-4763c950c582?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80';
const accessoryImage1 = 'https://images.unsplash.com/photo-1587304331256-7e7bbe9b3a0b?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80';
const homeFragranceImage1 = 'https://images.unsplash.com/photo-1601483212352-15da9b459752?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80';
const skincareImage1 = 'https://images.unsplash.com/photo-1598440947619-2c35fc9aa908?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80';

export const mockCategories: Category[] = [
  {
    id: 'perfumes',
    name: 'Perfumes',
    description: 'Luxurious perfumes for men and women',
    image: perfumesImg,
  },
  {
    id: 'oud',
    name: 'Oud & Fragrance Oils',
    description: 'Premium oud and fragrance oils',
    image: oudImage1,
  },
  {
    id: 'gift-sets',
    name: 'Gift Sets',
    description: 'Perfect gift sets for your loved ones',
    image: giftSetsImg,
  },
  {
    id: 'accessories',
    name: 'Accessories',
    description: 'Elegant perfume accessories',
    image: accessoryImage1,
  },
  {
    id: 'home-fragrance',
    name: 'Home Fragrance',
    description: 'Make your home smell wonderful',
    image: homeFragranceImage1,
  },
  {
    id: 'skincare',
    name: 'Skincare',
    description: 'Luxury skincare products',
    image: skincareImage1,
  },
];

export const mockProducts: Product[] = [
  {
    id: 'p1',
    name: 'Midnight Oud',
    description: 'A rich and sophisticated fragrance that combines deep oud with notes of amber and sandalwood for a luxurious scent experience.',
    price: 120,
    images: [perfumeImage1, perfumeImage2],
    category: 'perfumes',
    tags: ['oud', 'luxury', 'evening'],
    inStock: true,
    featured: true,
    rating: 4.8,
    reviews: [
      {
        id: 'r1',
        userId: 'u1',
        userName: 'Ahmed Ali',
        rating: 5,
        comment: 'The best oud perfume I have ever used. Long-lasting and elegant.',
        date: '2023-07-15',
      },
      {
        id: 'r2',
        userId: 'u2',
        userName: 'Fatima Hassan',
        rating: 4,
        comment: 'Beautiful scent, but a bit strong for everyday use.',
        date: '2023-08-22',
      },
    ],
  },
  {
    id: 'p2',
    name: 'Arabian Rose',
    description: 'A delicate blend of Arabian rose with touches of musk and vanilla, creating an elegant and feminine fragrance.',
    price: 95,
    discountPrice: 85,
    images: [perfumeImage2, perfumeImage3],
    category: 'perfumes',
    tags: ['rose', 'floral', 'feminine'],
    inStock: true,
    featured: true,
    rating: 4.5,
    reviews: [
      {
        id: 'r3',
        userId: 'u3',
        userName: 'Huda Rahman',
        rating: 5,
        comment: 'This has become my signature scent. I receive compliments every time I wear it.',
        date: '2023-09-10',
      },
    ],
  },
  {
    id: 'p3',
    name: 'Royal Amber',
    description: 'A majestic fragrance combining the richness of amber with woody notes, perfect for special occasions.',
    price: 150,
    images: [perfumeImage3, perfumeImage1],
    category: 'perfumes',
    tags: ['amber', 'woody', 'luxury'],
    inStock: true,
    rating: 4.7,
  },
  {
    id: 'p4',
    name: 'Premium Cambodian Oud Oil',
    description: 'Pure Cambodian oud oil with a deep, rich aroma that lasts for days.',
    price: 220,
    images: [oudImage1],
    category: 'oud',
    tags: ['pure oud', 'premium', 'long-lasting'],
    inStock: true,
    featured: true,
    rating: 5.0,
  },
  {
    id: 'p5',
    name: 'Luxury Gift Set',
    description: 'A premium gift set containing our bestselling perfumes: Midnight Oud, Arabian Rose, and Royal Amber.',
    price: 320,
    discountPrice: 290,
    images: [giftSetsImg],
    category: 'gift-sets',
    tags: ['gift', 'collection', 'luxury'],
    inStock: true,
    featured: true,
    rating: 4.9,
  },
  {
    id: 'p6',
    name: 'Crystal Perfume Atomizer',
    description: 'Elegant crystal atomizer for your favorite fragrances.',
    price: 45,
    images: [accessoryImage1],
    category: 'accessories',
    tags: ['atomizer', 'crystal', 'elegant'],
    inStock: true,
    rating: 4.3,
  },
  {
    id: 'p7',
    name: 'Amber & Oud Reed Diffuser',
    description: 'Long-lasting reed diffuser that fills your home with the luxurious scent of amber and oud.',
    price: 70,
    images: [homeFragranceImage1],
    category: 'home-fragrance',
    tags: ['reed diffuser', 'home', 'long-lasting'],
    inStock: true,
    featured: true,
    rating: 4.6,
  },
  {
    id: 'p8',
    name: 'Rose Infused Face Oil',
    description: 'Nourishing face oil infused with Damascene rose for radiant skin.',
    price: 85,
    images: [skincareImage1],
    category: 'skincare',
    tags: ['face oil', 'rose', 'hydrating'],
    inStock: true,
    rating: 4.7,
  },
  {
    id: 'p9',
    name: 'Desert Night',
    description: 'An intoxicating fragrance inspired by Arabian nights, with notes of spice, leather, and musk.',
    price: 110,
    images: [perfumesImg],
    category: 'perfumes',
    tags: ['spicy', 'leather', 'evening'],
    inStock: true,
    rating: 4.4,
  },
  {
    id: 'p10',
    name: 'Bakhoor Gift Set',
    description: 'Traditional Arabian bakhoor set with burner and premium wood chips.',
    price: 140,
    images: [homeFragranceImage1],
    category: 'home-fragrance',
    tags: ['bakhoor', 'traditional', 'gift'],
    inStock: true,
    rating: 4.8,
  },
  {
    id: 'p11',
    name: 'Jasmine Dreams',
    description: 'A light and refreshing jasmine-based perfume with citrus top notes.',
    price: 90,
    images: [perfumeImage2],
    category: 'perfumes',
    tags: ['jasmine', 'fresh', 'daytime'],
    inStock: true,
    rating: 4.5,
  },
  {
    id: 'p12',
    name: 'Golden Saffron',
    description: 'Luxury perfume featuring rare saffron notes combined with vanilla and amber.',
    price: 175,
    images: [perfumeImage3],
    category: 'perfumes',
    tags: ['saffron', 'luxury', 'unique'],
    inStock: false,
    featured: true,
    rating: 4.9,
  },
]; 